module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('span', {
    staticClass: "title grey--text"
  }, [_vm._v("Blocks")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "accent--text ma-0",
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": _vm.prepareCreateBlock
    }
  }, [_vm._v("Add New")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.facSet,
      "items": _vm.blockList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareEditBlock(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.block_nm ? props.item.block_nm : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.floors ? props.item.floors : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.flats ? props.item.flats : '-'))])])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Applicable Water Types")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "accent--text ma-0",
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": _vm.prepareCreateWaterType
    }
  }, [_vm._v("Add New")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.watType,
      "items": _vm.typeList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareEditWaterType(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.water_type))]), _vm._v(" "), _c('td', [_c('v-icon', {
          attrs: {
            "color": props.item.is_source ? 'green' : 'red'
          }
        }, [_vm._v(_vm._s(props.item.is_source ? 'check' : 'close'))])], 1)])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Water Quality Param")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "accent--text ma-0",
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": _vm.prepareCreateWaterQual
    }
  }, [_vm._v("Add New")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    staticClass: "tblWaterQual",
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.watQual : _vm.watQualsm,
      "items": _vm.qualList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareEditWaterQual(props.item)
            }
          }
        }, [_c('td', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.dragElement()
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("zoom_out_map")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.water_type ? props.item.water_type : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.param_name ? props.item.param_name : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.uom ? props.item.uom : '-'))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.std_val_min ? props.item.std_val_min : 0))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.std_val_max ? props.item.std_val_max : 0))]) : _vm._e()])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Water Storage")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "accent--text ma-0",
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": _vm.prepareCreateStorage
    }
  }, [_vm._v("Add New")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.waterStorage : _vm.waterStorageSm,
      "items": _vm.storageList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareEditStorage(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.storage_nm ? props.item.storage_nm : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.water_cat))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.storage_cap ? props.item.storage_cap : '-'))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [(props.item.is_level_checked) ? _c('v-icon', {
          attrs: {
            "color": "green"
          }
        }, [_vm._v("check")]) : _c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [(props.item.is_cons_checked) ? _c('v-icon', {
          attrs: {
            "color": "green"
          }
        }, [_vm._v("check")]) : _c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("close")])], 1) : _vm._e()])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Power Meters")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "accent--text ma-0",
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": _vm.prepareCreateMeter
    }
  }, [_vm._v("Add New")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.powerMeter,
      "items": _vm.meterList.filter(function (rec) { return rec.meter_nm !== ''; }),
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareEditMeter(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.meter_nm ? props.item.meter_nm : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.meter_location ? props.item.meter_location : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.area_covered ? props.item.area_covered : '-'))])])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Gensets")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "accent--text ma-0",
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": _vm.prepareCreateGensets
    }
  }, [_vm._v("Add New")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.genSets : _vm.genSetsSm,
      "items": _vm.gensetList.filter(function (rec) { return rec.genset_nm !== ''; }),
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareEditGensets(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.genset_nm ? props.item.genset_nm : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.genset_rating ? props.item.genset_rating : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.genset_cap))])])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Sanity Checks")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "accent--text ma-0",
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": _vm.prepareCreateSanCheck
    }
  }, [_vm._v("Add New")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.hygHead,
      "items": _vm.sanCheckList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareEditSanCheck(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.check_cat ? props.item.check_cat : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.check_desc ? props.item.check_desc : '-'))])])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Other Custom Metrics")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "accent--text ma-0",
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": _vm.prepareCreateCusMet
    }
  }, [_vm._v("Add New")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.cusMet,
      "items": _vm.metricList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareEditCusMet(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.metric_cat ? props.item.metric_cat : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.metric_nm ? props.item.metric_nm : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.period_display ? props.item.period_display : '-'))])])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Daily Update Photo Categories")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "accent--text ma-0",
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": _vm.prepareCreatePhotoCat
    }
  }, [_vm._v("Add New")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.photoCatHeader,
      "items": _vm.photoCat,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareEditPhotoCat(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.attach_cat_name))])])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Security Gaurd Posts")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "accent--text ma-0",
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": _vm.prepareCreateSecPost
    }
  }, [_vm._v("Add New")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.secPostHeader,
      "items": _vm.secPostList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareEditSecPost(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.security_post))])])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Notifications for Daily Report")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Mail ids",
      "hide-details": "",
      "maxlength": "200",
      "placeholder": "Notification mail ids(comma seperated)"
    },
    model: {
      value: (_vm.lReport.email_list),
      callback: function($$v) {
        _vm.$set(_vm.lReport, "email_list", $$v)
      },
      expression: "lReport.email_list"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "accent",
    on: {
      "click": function($event) {
        return _vm.saveDailyReportMailIds(_vm.lReport.email_list)
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Notifications for Weekly Report")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Mail ids for weekly report",
      "hide-details": "",
      "maxlength": "200",
      "placeholder": "Notification mail ids(comma seperated)"
    },
    model: {
      value: (_vm.lReport.email_wlist),
      callback: function($$v) {
        _vm.$set(_vm.lReport, "email_wlist", $$v)
      },
      expression: "lReport.email_wlist"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "accent",
    on: {
      "click": function($event) {
        return _vm.saveWeeklyReportMailIds(_vm.lReport.email_wlist)
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Other configurations")])]), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['Manual', 'FC Device'],
      "label": "Attendance device type",
      "outlined": ""
    },
    model: {
      value: (_vm.lReport.att_dev_type),
      callback: function($$v) {
        _vm.$set(_vm.lReport, "att_dev_type", $$v)
      },
      expression: "lReport.att_dev_type"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "accent",
    on: {
      "click": function($event) {
        return _vm.saveOtherConfigs(_vm.lReport.att_dev_type)
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Smartility IoT Devices")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "accent--text ma-0",
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": _vm.prepareCreateSmartDevice
    }
  }, [_vm._v("Add New")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.smartDev,
      "items": _vm.deviceList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareEditSmartDevice(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.smart_dev_type ? props.item.smart_dev_type : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.smart_dev_sno ? props.item.smart_dev_sno : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.smart_dev_loc ? props.item.smart_dev_loc : '-'))])])]
      }
    }])
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showBlock),
      callback: function($$v) {
        _vm.showBlock = $$v
      },
      expression: "showBlock"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges(_vm.lBlock.action)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n            " + _vm._s(_vm.lBlock.action) + " Block\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Block Name",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "25"
    },
    model: {
      value: (_vm.lBlock.block_nm),
      callback: function($$v) {
        _vm.$set(_vm.lBlock, "block_nm", $$v)
      },
      expression: "lBlock.block_nm"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Floors",
      "hide-details": "",
      "type": "number",
      "maxlength": "11"
    },
    model: {
      value: (_vm.lBlock.floors),
      callback: function($$v) {
        _vm.$set(_vm.lBlock, "floors", $$v)
      },
      expression: "lBlock.floors"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Flats",
      "hide-details": "",
      "type": "number",
      "maxlength": "11"
    },
    model: {
      value: (_vm.lBlock.flats),
      callback: function($$v) {
        _vm.$set(_vm.lBlock, "flats", $$v)
      },
      expression: "lBlock.flats"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showBlock = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lBlock.action === 'Update') ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteBlock(_vm.lBlock)
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showWaterType),
      callback: function($$v) {
        _vm.showWaterType = $$v
      },
      expression: "showWaterType"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveWaterTypeChanges(_vm.lWaterType.action)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n            " + _vm._s(_vm.lWaterType.action) + " Water Type\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.masterTypeList,
      "label": "Water Type",
      "hide-details": "",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lWaterType.water_type),
      callback: function($$v) {
        _vm.$set(_vm.lWaterType, "water_type", $$v)
      },
      expression: "lWaterType.water_type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Source of water to this community",
      "hide-details": ""
    },
    model: {
      value: (_vm.lWaterType.is_source),
      callback: function($$v) {
        _vm.$set(_vm.lWaterType, "is_source", $$v)
      },
      expression: "lWaterType.is_source"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showWaterType = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lWaterType.action === 'Update') ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteWaterType(_vm.lWaterType)
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showWaterQuality),
      callback: function($$v) {
        _vm.showWaterQuality = $$v
      },
      expression: "showWaterQuality"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveWatQualChanges(_vm.lWaterQual.action)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n            " + _vm._s(_vm.lWaterQual.action) + " Water Quality\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Water Type",
      "items": _vm.typeList,
      "item-text": "water_type",
      "return-object": "",
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        return _vm.loadWaterQualityReference(_vm.lWaterQual.water_type_pair.water_type_id)
      }
    },
    model: {
      value: (_vm.lWaterQual.water_type_pair),
      callback: function($$v) {
        _vm.$set(_vm.lWaterQual, "water_type_pair", $$v)
      },
      expression: "lWaterQual.water_type_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Parameter Name",
      "items": _vm.paramList.map(function (rec) { return rec.param_name; }),
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        return _vm.loadBasedParamName(_vm.lWaterQual.param_name, _vm.lWaterQual.water_type_id)
      }
    },
    model: {
      value: (_vm.lWaterQual.param_name),
      callback: function($$v) {
        _vm.$set(_vm.lWaterQual, "param_name", $$v)
      },
      expression: "lWaterQual.param_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "UoM",
      "hide-details": "",
      "maxlength": "10"
    },
    model: {
      value: (_vm.lWaterQual.uom),
      callback: function($$v) {
        _vm.$set(_vm.lWaterQual, "uom", $$v)
      },
      expression: "lWaterQual.uom"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Min",
      "hide-details": "",
      "type": "number"
    },
    model: {
      value: (_vm.lWaterQual.std_val_min),
      callback: function($$v) {
        _vm.$set(_vm.lWaterQual, "std_val_min", $$v)
      },
      expression: "lWaterQual.std_val_min"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Max",
      "hide-details": "",
      "type": "number"
    },
    model: {
      value: (_vm.lWaterQual.std_val_max),
      callback: function($$v) {
        _vm.$set(_vm.lWaterQual, "std_val_max", $$v)
      },
      expression: "lWaterQual.std_val_max"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showWaterQuality = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lWaterQual.action === 'Update') ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteQual(_vm.lWaterQual)
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.showWaterStorage),
      callback: function($$v) {
        _vm.showWaterStorage = $$v
      },
      expression: "showWaterStorage"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveStorageChanges(_vm.lStorage.action)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n            " + _vm._s(_vm.lStorage.action) + " Water Storage\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Storage Name",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "25"
    },
    model: {
      value: (_vm.lStorage.storage_nm),
      callback: function($$v) {
        _vm.$set(_vm.lStorage, "storage_nm", $$v)
      },
      expression: "lStorage.storage_nm"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Storage Capacity",
      "hide-details": "",
      "type": "number",
      "maxlength": "11"
    },
    model: {
      value: (_vm.lStorage.storage_cap),
      callback: function($$v) {
        _vm.$set(_vm.lStorage, "storage_cap", $$v)
      },
      expression: "lStorage.storage_cap"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['Domestic', 'Recycled/Treated'],
      "label": "Category",
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    model: {
      value: (_vm.lStorage.water_cat),
      callback: function($$v) {
        _vm.$set(_vm.lStorage, "water_cat", $$v)
      },
      expression: "lStorage.water_cat"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-2",
    attrs: {
      "label": "Is Level Checked?",
      "hide-details": ""
    },
    model: {
      value: (_vm.lStorage.is_level_checked),
      callback: function($$v) {
        _vm.$set(_vm.lStorage, "is_level_checked", $$v)
      },
      expression: "lStorage.is_level_checked"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-2",
    attrs: {
      "label": "Is Consumption Checked?",
      "hide-details": ""
    },
    model: {
      value: (_vm.lStorage.is_cons_checked),
      callback: function($$v) {
        _vm.$set(_vm.lStorage, "is_cons_checked", $$v)
      },
      expression: "lStorage.is_cons_checked"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-3 pb-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text subheader pa-0"
  }, [_vm._v("Real Time Monitoring")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['Waltr', 'Waterize'],
      "placeholder": "No RTM Installed",
      "clearable": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.lStorage.rtm_provider),
      callback: function($$v) {
        _vm.$set(_vm.lStorage, "rtm_provider", $$v)
      },
      expression: "lStorage.rtm_provider"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.lStorage.rtm_provider ? _vm.lStorage.rtm_provider + ' Tank Id' : '',
      "rules": _vm.lStorage.rtm_provider ? [_vm.rules.required] : [],
      "hide-details": ""
    },
    model: {
      value: (_vm.lStorage.rtm_integrate_id_1),
      callback: function($$v) {
        _vm.$set(_vm.lStorage, "rtm_integrate_id_1", $$v)
      },
      expression: "lStorage.rtm_integrate_id_1"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-3 pb-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text subheader pa-0"
  }, [_vm._v("Water Level Alert")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Min Water Level (%)",
      "type": "number",
      "hide-details": "",
      "disabled": _vm.lStorage.is_level_checked ? false : true
    },
    model: {
      value: (_vm.lStorage.min_level),
      callback: function($$v) {
        _vm.$set(_vm.lStorage, "min_level", $$v)
      },
      expression: "lStorage.min_level"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Max Water Level (%)",
      "type": "number",
      "hide-details": "",
      "disabled": _vm.lStorage.is_level_checked ? false : true
    },
    model: {
      value: (_vm.lStorage.max_level),
      callback: function($$v) {
        _vm.$set(_vm.lStorage, "max_level", $$v)
      },
      expression: "lStorage.max_level"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showWaterStorage = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lStorage.action === 'Update') ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteStorage(_vm.lStorage)
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showPowerMeter),
      callback: function($$v) {
        _vm.showPowerMeter = $$v
      },
      expression: "showPowerMeter"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveMeterChanges(_vm.lPowerMeter.action)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n            " + _vm._s(_vm.lPowerMeter.action) + " Power Meter\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Meter Name",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "25"
    },
    model: {
      value: (_vm.lPowerMeter.meter_nm),
      callback: function($$v) {
        _vm.$set(_vm.lPowerMeter, "meter_nm", $$v)
      },
      expression: "lPowerMeter.meter_nm"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Meter Location",
      "hide-details": "",
      "maxlength": "25"
    },
    model: {
      value: (_vm.lPowerMeter.meter_location),
      callback: function($$v) {
        _vm.$set(_vm.lPowerMeter, "meter_location", $$v)
      },
      expression: "lPowerMeter.meter_location"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Area Covered",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "15"
    },
    model: {
      value: (_vm.lPowerMeter.area_covered),
      callback: function($$v) {
        _vm.$set(_vm.lPowerMeter, "area_covered", $$v)
      },
      expression: "lPowerMeter.area_covered"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showPowerMeter = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lPowerMeter.action === 'Update') ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteMeter(_vm.lPowerMeter)
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showGenset),
      callback: function($$v) {
        _vm.showGenset = $$v
      },
      expression: "showGenset"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveGenChanges(_vm.lGen.action)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n            " + _vm._s(_vm.lGen.action) + " Genset\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Genset Name",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "15"
    },
    model: {
      value: (_vm.lGen.genset_nm),
      callback: function($$v) {
        _vm.$set(_vm.lGen, "genset_nm", $$v)
      },
      expression: "lGen.genset_nm"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Genset Rating",
      "hide-details": "",
      "maxlength": "15"
    },
    model: {
      value: (_vm.lGen.genset_rating),
      callback: function($$v) {
        _vm.$set(_vm.lGen, "genset_rating", $$v)
      },
      expression: "lGen.genset_rating"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Genset Capacity (ltr)",
      "hide-details": "",
      "maxlength": "15",
      "type": "number"
    },
    model: {
      value: (_vm.lGen.genset_cap),
      callback: function($$v) {
        _vm.$set(_vm.lGen, "genset_cap", $$v)
      },
      expression: "lGen.genset_cap"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showGenset = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lGen.action === 'Update') ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteGen(_vm.lGen)
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showCustomMetric),
      callback: function($$v) {
        _vm.showCustomMetric = $$v
      },
      expression: "showCustomMetric"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveCustomMetChanges(_vm.lCusMet.action)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n            " + _vm._s(_vm.lCusMet.action) + " Custom Metric\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Metric category",
      "items": _vm.metricList.map(function (rec) { return rec.metric_cat; }),
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "25"
    },
    model: {
      value: (_vm.lCusMet.metric_cat),
      callback: function($$v) {
        _vm.$set(_vm.lCusMet, "metric_cat", $$v)
      },
      expression: "lCusMet.metric_cat"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Metric Name",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.lCusMet.metric_nm),
      callback: function($$v) {
        _vm.$set(_vm.lCusMet, "metric_nm", $$v)
      },
      expression: "lCusMet.metric_nm"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "What to display when this metric is viewed for multiple days",
      "items": [{
        'value': 'A',
        'text': 'Average'
      }, {
        'value': 'T',
        text: 'Total'
      }],
      "item-value": "value",
      "item-text": "text",
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    model: {
      value: (_vm.lCusMet.period_display),
      callback: function($$v) {
        _vm.$set(_vm.lCusMet, "period_display", $$v)
      },
      expression: "lCusMet.period_display"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showCustomMetric = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lCusMet.action === 'Update') ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteMet(_vm.lCusMet)
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showSanChecks),
      callback: function($$v) {
        _vm.showSanChecks = $$v
      },
      expression: "showSanChecks"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "hForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveSanCheckChanges(_vm.lSanCheck.action)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n            " + _vm._s(_vm.lSanCheck.action) + " Sanity Check\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Category",
      "items": _vm.sanCheckList.map(function (rec) { return rec.check_cat; }),
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.lSanCheck.check_cat),
      callback: function($$v) {
        _vm.$set(_vm.lSanCheck, "check_cat", $$v)
      },
      expression: "lSanCheck.check_cat"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Description",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "150"
    },
    model: {
      value: (_vm.lSanCheck.check_desc),
      callback: function($$v) {
        _vm.$set(_vm.lSanCheck, "check_desc", $$v)
      },
      expression: "lSanCheck.check_desc"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showSanChecks = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lSanCheck.action === 'Update') ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteSanCheck(_vm.lSanCheck)
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showPhotoCat),
      callback: function($$v) {
        _vm.showPhotoCat = $$v
      },
      expression: "showPhotoCat"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.savePhotoCat(_vm.lPhotoCat.action)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n            " + _vm._s(_vm.lPhotoCat.action) + " Photo Category\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Category Name",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "100"
    },
    model: {
      value: (_vm.lPhotoCat.attach_cat_name),
      callback: function($$v) {
        _vm.$set(_vm.lPhotoCat, "attach_cat_name", $$v)
      },
      expression: "lPhotoCat.attach_cat_name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showPhotoCat = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lPhotoCat.action === 'Update') ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.deletePhotoCat(_vm.lPhotoCat)
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "300px"
    },
    model: {
      value: (_vm.showSecPost),
      callback: function($$v) {
        _vm.showSecPost = $$v
      },
      expression: "showSecPost"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "pForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveSecPost(_vm.lSecPost.action)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n            " + _vm._s(_vm.lSecPost.action) + " Security Post\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Post Name / Gaurd Location",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "10"
    },
    model: {
      value: (_vm.lSecPost.security_post),
      callback: function($$v) {
        _vm.$set(_vm.lSecPost, "security_post", $$v)
      },
      expression: "lSecPost.security_post"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showSecPost = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lSecPost.action === 'Update') ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteSecPost()
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showIoTDevices),
      callback: function($$v) {
        _vm.showIoTDevices = $$v
      },
      expression: "showIoTDevices"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveSmartDeviceChanges(_vm.lSmartDev.action)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n            " + _vm._s(_vm.lSmartDev.action) + " Smartility Device\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Type",
      "items": _vm.smartDevTypes,
      "item-value": "smart_dev_id",
      "item-text": "smart_dev_type",
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    model: {
      value: (_vm.lSmartDev.smart_dev_type),
      callback: function($$v) {
        _vm.$set(_vm.lSmartDev, "smart_dev_type", $$v)
      },
      expression: "lSmartDev.smart_dev_type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Serial Number",
      "hide-details": "",
      "maxlength": "10",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lSmartDev.smart_dev_sno),
      callback: function($$v) {
        _vm.$set(_vm.lSmartDev, "smart_dev_sno", $$v)
      },
      expression: "lSmartDev.smart_dev_sno"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Location",
      "maxlength": "10",
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    model: {
      value: (_vm.lSmartDev.smart_dev_loc),
      callback: function($$v) {
        _vm.$set(_vm.lSmartDev, "smart_dev_loc", $$v)
      },
      expression: "lSmartDev.smart_dev_loc"
    }
  })], 1), _vm._v(" "), (_vm.lSmartDev.smart_dev_type === 'FaceCheckin') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "primary--text mt-2"
  }, [_vm._v("Purpose")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "ma-0",
    attrs: {
      "row": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.lSmartDev.fcDevPurpose),
      callback: function($$v) {
        _vm.$set(_vm.lSmartDev, "fcDevPurpose", $$v)
      },
      expression: "lSmartDev.fcDevPurpose"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Time & Attendance",
      "value": "T"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Others",
      "value": "O"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "primary--text mt-2"
  }, [_vm._v("Mode")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "ma-0",
    attrs: {
      "row": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.lSmartDev.fc_inout_mode),
      callback: function($$v) {
        _vm.$set(_vm.lSmartDev, "fc_inout_mode", $$v)
      },
      expression: "lSmartDev.fc_inout_mode"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "IN/OUT",
      "value": "IN/OUT"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "IN Only",
      "value": "IN"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "OUT Only",
      "value": "OUT"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "primary--text mt-2"
  }, [_vm._v("Voice settings")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Voice enabled",
      "hide-details": ""
    },
    model: {
      value: (_vm.lSmartDev.fc_is_voice_enabled),
      callback: function($$v) {
        _vm.$set(_vm.lSmartDev, "fc_is_voice_enabled", $$v)
      },
      expression: "lSmartDev.fc_is_voice_enabled"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Pronounce user name",
      "hide-details": "",
      "disabled": !_vm.lSmartDev.fc_is_voice_enabled
    },
    model: {
      value: (_vm.lSmartDev.fc_is_name_read),
      callback: function($$v) {
        _vm.$set(_vm.lSmartDev, "fc_is_name_read", $$v)
      },
      expression: "lSmartDev.fc_is_name_read"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Languages",
      "items": ['eng', 'hi', 'kn', 'ms', 'ta'],
      "chips": "",
      "multiple": "",
      "disabled": !_vm.lSmartDev.fc_is_voice_enabled,
      "hide-details": ""
    },
    model: {
      value: (_vm.lSmartDev.fcLangList),
      callback: function($$v) {
        _vm.$set(_vm.lSmartDev, "fcLangList", $$v)
      },
      expression: "lSmartDev.fcLangList"
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showIoTDevices = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lSmartDev.action === 'Update') ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteSmartDevice(_vm.lSmartDev)
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 3000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1518f342","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Facconfig.vue
// module id = 795
// module chunks = 21